import React from "react";
import Footer from "../../components/Footer/Footer";
import FullNews from "../../components/FullNews/FullNews";
import News from "../../components/News/News";

const newsList = [
  {
    title: "A",
    text: "Acabamos de lançar o novo site da empresa, com design moderno e mais funcionalidades para os nossos clientes.",
    link: "news1"
  },
  {
    title: "B",
    text: "Durante todo o mês de agosto, oferecemos condições especiais para quem vender sua cota conosco.",
    link: "news2"
  },
  {
    title: "C",
    text: "Durante todo o mês de agosto, oferecemos condições especiais para quem vender sua cota conosco.",
    link: "news3"
  }
];

const newsList2 = [
  {
    title: "D",
    text: "Acabamos de lançar o novo site da empresa, com design moderno e mais funcionalidades para os nossos clientes.",
    link: "news4"
  },
  {
    title: "E",
    text: "Durante todo o mês de agosto, oferecemos condições especiais para quem vender sua cota conosco.",
    link: "news5"
  },
  {
    title: "F",
    text: "Durante todo o mês de agosto, oferecemos condições especiais para quem vender sua cota conosco.",
    link: "news6"
  }
];

const fullList = [
  {
    title: "Tambem é noticia",
    text: "Lorem Ipsum é simplesmente uma simulação de texto da indústria tipográfica e de impressos, e vem sendo utilizado desde o século XVI, quando um impressor desconhecido pegou uma bandeja de tipos e os embaralhou para fazer um livro de modelos de tipos. Lorem Ipsum sobreviveu não só a cinco séculos, como também ao salto para a editoração eletrônica.",
    subText: "permanecendo essencialmente inalterado. Se popularizou na década de 60, quando a Letraset lançou decalques contendo passagens de Lorem Ipsum, e mais recentemente quando passou a ser integrado a softwares de editoração eletrônica como Aldus PageMaker.",
    link: "news7"
  },
];

function Blog() {
  return (
    <section className="flex flex-col absolute h-screen min-h-full w-full">
      <div className="relative">
        <div className="flex w-full h-full z-10 absolute items-center justify-center">
          <div className="mx-auto my-auto">
            <span className="text-3xl font-extrabold font-raleway text-white" id="blog" >Nosso Blog</span>
          </div>
        </div>
        <img src="contact.png" alt="logo" className='z-0 top-0 left-0 w-full' />
      </div>
      <div className="flex w-full z-0 pt-9 pb-9">
        <FullNews list={fullList} />
      </div>
      <div className="flex w-full z-0 pt-9">
        <News list={newsList} />
      </div>
      <div className="flex w-full z-0 pt-9">
        <News list={newsList2} />
      </div>
      <div className="flex w-full z-0 pt-9">
        <Footer />
      </div>
    </section>
  );
}

export default Blog;